import {gql} from '@apollo/client'

export const GET_SERVICE = gql`
  query GetService($serviceId: ID!) {
    service(id: $serviceId) {
      id
      address
      status
      description
      coords
      macAddress
      ipAddress
      plan {
        id
        name
      }
      account {
        displayName @client
        name
        contactFirstName
        contactLastName
      }
    }
  }
`

export const CREATE_SERVICE = gql`
  mutation CreateService(
    $accountId: ID!
    $address: String
    $description: String
    $coords: JSON
    $macAddress: String
    $ipAddress: String
    $planId: ID
    $status: String
  ) {
    service(
      accountId: $accountId
      address: $address
      description: $description
      coords: $coords
      macAddress: $macAddress
      ipAddress: $ipAddress
      planId: $planId
      status: $status
    ) {
      id
      address
      status
      description
      coords
      macAddress
      ipAddress
      plan {
        id
        name
      }
      account {
        displayName @client
        name
        contactFirstName
        contactLastName
      }
    }
  }
`

export const UPDATE_SERVICE = gql`
  mutation UpdateService(
    $serviceId: ID!
    $accountId: ID
    $address: String
    $description: String
    $coords: JSON
    $macAddress: String
    $ipAddress: String
    $planId: ID
    $status: String
  ) {
    service(
      id: $serviceId
      accountId: $accountId
      address: $address
      description: $description
      coords: $coords
      status: $status
      macAddress: $macAddress
      ipAddress: $ipAddress
      planId: $planId
    ) {
      id
      address
      status
      description
      coords
      macAddress
      ipAddress
      plan {
        id
        name
      }
      account {
        displayName @client
        name
        contactFirstName
        contactLastName
      }
    }
  }
`
